/* eslint-disable react/prop-types */
import React from "react";
import axios from 'axios';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-kit-react/views/personalInformationPage.js";
import { Trans, useTranslation } from 'react-i18next';
import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, MenuItem, Radio, RadioGroup, Select } from "@material-ui/core";
// import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';

import countriesdata from "assets/config/countriesdata.json";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles(styles);

function PersonalInformationPageInside(props) {

    const { history } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    var formControlPropsClassName = { fullWidth: true };
    var formControlClasses = classNames(
        formControlPropsClassName,
        classes.formControl
    )
    const [state, setState] = React.useState({
        name: "",
        surname: "",
        personalmail: "",
        professionalmail: "",
        preferredmail: "",
        // fiscalid: "",
        company: "",
        position: "",
        address: "",
        city: "",
        zip: "",
        province: "",
        country: "",
        amount: "",
        termsAgreed: false,
        showTermsAgreedError: false
    });
    let personalinfopre;
    if (props.personalInfoData) {
        personalinfopre = props.personalInfoData;
    }
    React.useEffect(() => {
        if (props.personalInfoData) {
            setState({
                ...state,
                ['name']: props.personalInfoData.name,
                ['surname']: props.personalInfoData.surname,
                ['personalmail']: props.personalInfoData.personalmail,
                ['professionalmail']: props.personalInfoData.professionalmail,
                ['preferredmail']: props.personalInfoData.preferredmail,
                // ['fiscalid']: props.personalInfoData.fiscalid,
                ['company']: props.personalInfoData.company,
                ['position']: props.personalInfoData.position,
                ['address']: props.personalInfoData.address,
                ['city']: props.personalInfoData.city,
                ['zip']: props.personalInfoData.zip,
                ['province']: props.personalInfoData.province,
                ['country']: props.personalInfoData.country,
                ['amount']: props.personalInfoData.amount.toFixed(2)
            });
        }
    }, []);
    const handlePreferredmailChange = function (event) {
        setState({
            ...state,
            ['preferredmail']: event.target.value
        });
    }
    const handleChange = (event) => {
        const name = event.target.name;
        setState({
            ...state,
            [name]: event.target.value,
        });
    };
    const handleChangeId = (event) => {
        const name = event.target.id;
        setState({
            ...state,
            [name]: event.target.value,
        });
    };
    const handleTermsAgreement = function (event) {
        setState({
            ...state,
            ['termsAgreed']: event.target.checked,
            ['showTermsAgreedError']: !event.target.checked
        });
        if (event.target.checked) {
            document.getElementById("info").style.visibility = "hidden";
        }
    }
    const setTermsIncorrect = function () {
        setState({
            ...state,
            ['showTermsAgreedError']: true
        });
        document.getElementById("info").style.visibility = "visible";
    }
    // const selectCountry = (val) => {
    //     setState({
    //         ...state,
    //         ['country']: val
    //     });
    // };

    // const selectRegion = (val) => {
    //     setState({
    //         ...state,
    //         ['province']: val
    //     });
    // };
    // const [loading, setLoading] = React.useState(false);
    const isNullorWhiteSpace = function (input) {
        return !/\S/.test(input);
    }
    const validateEmail = function (email) {
        const validEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return validEmailRegex.test(email);
    }
    const handleSubmissionPersonalInfo = () => {
       if (!validateEmail(state.personalmail) || 
            //!validateEmail(state.professionalmail) ||
          (!isNullorWhiteSpace(state.professionalmail) && (!validateEmail(state.professionalmail) || state.professionalmail.trim().toLowerCase() == state.personalmail.trim().toLowerCase())) ||
            isNullorWhiteSpace(state.company) ||
            isNullorWhiteSpace(state.position) || isNullorWhiteSpace(state.address) ||
            isNullorWhiteSpace(state.city) || isNullorWhiteSpace(state.zip) || isNullorWhiteSpace(state.province)) {
            document.getElementById("info").style.visibility = "visible";
            return;
        }
        if (isNullorWhiteSpace(state.professionalmail)) {
            state.preferredmail = "email";
        }
        // setLoading(true);
        const personalinfopost = {
            name: state.name,
            surname: state.surname,
            personalmail: state.personalmail,
            professionalmail: state.professionalmail,
            preferredmail: state.preferredmail,
            // fiscalid: state.fiscalid,
            company: state.company,
            position: state.position,
            address: state.address,
            city: state.city,
            zip: state.zip,
            province: state.province,
            country: state.country,
            amount: 0
        }
        personalinfopre.amount = 0;
        const client = {
            personalinfopost,
            personalinfopre
        };
        axios.post("/savepersonalinfo", client
        )
            .then(() => {
                // setLoading(false);
                history.push('/paymentmethod');

                return;
            }).catch(function (error) {
                if (error.response !== undefined && error.response.status !== null && error.response.status === 400) {
                    document.getElementById("info").style.visibility = "visible";
                }
                else {
                    document.getElementById("error").style.visibility = 'visible';
                }

                // setLoading(false);
            });

    }

   countriesdata.countries.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
    let countriesItems = [];
    {
        (function (rows, i, len) {
            while (i <= len) {
               rows.push(<MenuItem key={i} value={countriesdata.countries[i].value}>{countriesdata.countries[i].text}</MenuItem>)
                i++
            }
            return rows;
        })(countriesItems, 0, countriesdata.countries.length - 1)
    }

    if (!props.personalInfoData) return (null);

    return (
        <div className="paddingBottom90">
            <div className={classes.titleheader}>
                <div className="semibold-b100 cl-secondary-500">{t("PersonalInformationHeader_Step1")}</div>
                <div className="semibold-h500 paddingTop16">{t("PersonalInformationHeader_Title")}</div>
            </div>
            <div className="flexWrapper equals bg-brown-light paddingLeftRight64 paddingTop20 paddingBottom24 stickyHeader featuresHeaderMobile">
                <div>
                    <div className="featuresHeaderMobile flexWrapper mobilerow">
                        <div>
                            <div className="semibold-h200 cl-secondary-900">{t("PersonalInformationHeader_Subscription")}</div>
                        </div>
                        <div>
                            <span className="paddingRight40">
                                <div className="semibold-h300 cl-secondary-900">
                                    {state.amount.toString().replace(".", ",")}€
                                </div>
                                <div className="semibold-b100 cl-secondary-500 textRight">
                                    {t("PerYearLiteral")}
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-brown-light paddingLeftRight64 paddingBottom20 featuresHeaderMobile">
                <div className="paddingTop8 regular-b300 cl-secondary-900">
                    <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature1")}</span>
                    <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature2")}</span>
                    <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature3")}</span>
                    <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature4")}</span>
                    <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature5")}</span>
                </div>
            </div>
            <div className="flexWrapper bg-brown-light paddingLeftRight64 paddingTopBottom20 stickyHeader notshowmobile">
                <div>
                    <div className="featuresHeaderMobile flexWrapper mobilerow">
                        <div>
                            <div className="semibold-h200 cl-secondary-900">{t("PersonalInformationHeader_Subscription")}</div>
                        </div>
                        <div>
                            <span className="paddingRight40">
                                <div className="semibold-h300 cl-secondary-900" id="personalInfoAmountSpec">
                                    {state.amount.toString().replace(".", ",")}€
                                </div>
                                <div className="semibold-b100 cl-secondary-500 textRight">
                                    {t("PerYearLiteral")}
                                </div>
                            </span>
                        </div>
                    </div>
                    <div className="notshowmobile semibold-h200 cl-secondary-900">{t("PersonalInformationHeader_Subscription")}</div>
                    <div className="paddingTop8 regular-b300 cl-secondary-900">
                        <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature1")}</span>
                        <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature2")}</span>
                        <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature3")}</span>
                        <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature4")}</span>
                        <span className="firstTimeFeature">{t("PersonalInformation_Footer_Feature5")}</span>
                    </div>
                </div>
                <div className={classes.flexLeftSubmitButton + " notshowmobile"}>
                    <span className="paddingRight40">
                        <div className="semibold-h300 cl-secondary-900">
                            {state.amount.toString().replace(".", ",")}€
                        </div>
                        <div className="semibold-b100 cl-secondary-500 textRight">
                            {t("PerYearLiteral")}
                        </div>
                    </span>
                </div>
            </div>
            <div className="blockHeight64"></div>
            <div className="paddingLeftRight64">
                <div className="flexWrapper equals">
                    <div>
                        <div className="semibold-h200">{t("PersonalInformationDetails_Title")}</div>
                        <div className="semibold-b100 cl-primary-500 paddingTop16">{t("PersonalInformationDetails_Subtitle")}</div>
                    </div>
                    <div className="paddingLeft16 NoMobile">
                        <div className="flexWrapper equals">
                            <div>
                                <CustomInput
                                    labelText={t("PersonalInformation_Field_Name")}
                                    id="name"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: state.name
                                    }}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <CustomInput
                                    labelText={t("PersonalInformation_Field_LastName")}
                                    id="surname"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: state.surname
                                    }}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <CustomInput
                            labelText={t("PersonalInformation_Field_PersonalMail")}
                            placeholder="example@gmail.com"
                            id="personalmail"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                value: state.personalmail
                            }}
                      helperMessage={state.professionalmail.trim().toLowerCase() == state.personalmail.trim().toLowerCase() ? t("PersonalProfessionalEqualFieldError") : t("RequiredFieldError")}
                      error={!/\S/.test(state.personalmail) || state.professionalmail.trim().toLowerCase() == state.personalmail.trim().toLowerCase()}
                            onChange={handleChangeId}
                        />
                        <CustomInput
                            labelText={t("PersonalInformation_Field_ProfessionalMail")}
                            placeholder="example@company.com"
                            id="professionalmail"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                value: state.professionalmail
                            }}
                      helperMessage={state.professionalmail.trim().toLowerCase() == state.personalmail.trim().toLowerCase() ? t("PersonalProfessionalEqualFieldError") : t("RequiredFieldError")}
                      error={state.professionalmail.trim().toLowerCase() == state.personalmail.trim().toLowerCase()}
                            onChange={handleChangeId}
                        />
                        <FormControl className={formControlClasses}>
                            <label
                                className="cl-secondary-900 regular-b300"
                            >
                                {t("PersonalInformation_Field_PreferredMail")}
                            </label>
                            <RadioGroup row
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={state.preferredmail}
                                name="radio-buttons-group"
                                onChange={handlePreferredmailChange}
                            >
                                <FormControlLabel value="email" control={<Radio />} label={t("PersonalInformation_Literal_PersonalMail")} />
                                <FormControlLabel value="email2" control={<Radio />} label={t("PersonalInformation_Literal_ProfessionalMail")} />
                            </RadioGroup>
                        </FormControl>
                        {/* <CustomInput
                            labelText={t("PersonalInformation_Field_FiscalId")}
                            placeholder="00000000X"
                            id="fiscalid"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                value: state.fiscalid
                            }}
                            helperMessage={t("RequiredFieldError")}
                            error={!/\S/.test(state.fiscalid)}
                            onChange={handleChangeId}
                        /> */}
                        <div className="flexWrapper equals">
                            <div>
                                <CustomInput
                                    labelText={t("PersonalInformation_Field_Company")}
                                    placeholder=""
                                    id="company"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: state.company
                                    }}
                                    helperMessage={t("RequiredFieldError")}
                                    error={!/\S/.test(state.company)}
                                    onChange={handleChangeId}
                                />
                            </div>
                            <div>
                                <CustomInput
                                    labelText={t("PersonalInformation_Field_Position")}
                                    placeholder=""
                                    id="position"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: state.position
                                    }}
                                    helperMessage={t("RequiredFieldError")}
                                    error={!/\S/.test(state.position)}
                                    onChange={handleChangeId}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="customHr" />
                <div className="flexWrapper equals">
                    <div>
                        <div className="semibold-h200">{t("PersonalInformationAddress_Title")}</div>
                        <div className="semibold-b100 cl-primary-500 paddingTop16">{t("PersonalInformationAddress_Subtitle")}</div>
                    </div>
                    <div className="paddingLeft16 NoMobile">
                        <CustomInput
                            labelText={t("PersonalInformation_Field_Address")}
                            placeholder=""
                            id="address"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                value: state.address
                            }}
                            helperMessage={t("RequiredFieldError")}
                            error={!/\S/.test(state.address)}
                            onChange={handleChangeId}
                        />
                        <div className="flexWrapper equals">
                            <div>
                                <CustomInput
                                    labelText={t("PersonalInformation_Field_City")}
                                    placeholder=""
                                    id="city"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: state.city
                                    }}
                                    helperMessage={t("RequiredFieldError")}
                                    error={!/\S/.test(state.city)}
                                    onChange={handleChangeId}
                                />
                            </div>
                            <div>
                                <CustomInput
                                    labelText={t("PersonalInformation_Field_ZIP")}
                                    placeholder=""
                                    id="zip"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: state.zip
                                    }}
                                    helperMessage={t("RequiredFieldError")}
                                    error={!/\S/.test(state.zip)}
                                    onChange={handleChangeId}
                                />
                            </div>
                        </div>
                        <div className="flexWrapper equals">
                            <div>
                                {/* <FormControl className={formControlClasses}>
                                    <label
                                        className="cl-secondary-900 regular-b300"
                                        htmlFor="province"
                                    >
                                        {t("PersonalInformation_Field_Province")}
                                    </label>
                                    <RegionDropdown classes={ "personalInfoSelect" }
                                        country={state.country}
                                        value={state.province}
                                        onChange={selectRegion} />
                                </FormControl> */}
                                <CustomInput
                                    labelText={t("PersonalInformation_Field_Province")}
                                    placeholder=""
                                    id="province"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        value: state.province
                                    }}
                                    helperMessage={t("RequiredFieldError")}
                                    error={!/\S/.test(state.province)}
                                    onChange={handleChangeId}
                                />
                            </div>
                            <div>
                                <FormControl className={formControlClasses}>
                                    <label
                                        className="cl-secondary-900 regular-b300"
                                        htmlFor="country"
                                    >
                                        {t("PersonalInformation_Field_Country")}
                                    </label>
                                    <Select
                                        inputProps={{
                                            name: 'country',
                                            id: 'country',
                                        }}
                                        value={state.country}
                                        onChange={handleChange}
                                        className="personalInfoSelect"
                                        displayEmpty
                                    >
                                        {countriesItems}
                                    </Select>
                                    {/* <CountryDropdown classes={ "personalInfoSelect" }
                                        value={state.country}
                                        onChange={selectCountry} /> */}
                                </FormControl>
                            </div>
                        </div>
                        <div className="paddingTop20">
                            {state.showTermsAgreedError ? <FormHelperText error >{t("RequiredFieldError")}</FormHelperText> : ""}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className={classes.checkBox + " MyCheckbox"}
                                        color="default"
                                        checked={state.termsAgreed}
                                        onChange={handleTermsAgreement}
                                        name="termsAgreedOk"
                                    />
                                }
                                label={<>{t("PersonalInformation_AgreeTerms")}<a target='_blank' href={t("PersonalInformation_AgreeTermsOfUseUrl")} rel="noreferrer">{t("PersonalInformation_AgreeTermsOfUse")}</a>{t("PersonalInformation_AgreeTermsAnd")}<a target='_blank' href={t("PersonalInformation_AgreeTermsPrivacyUrl")} rel="noreferrer">{t("PersonalInformation_AgreeTermsPrivacy")}</a><Trans i18nKey="PersonalInformation_AgreeTermsInfo" components={{bold: <b />}} /></>}
                                className={classes.regularText + " regular-b200 textDecorationUnderline MyCheckboxWrapper"}
                            />
                        </div>
                    </div>
                </div>
                <div className="textCenter paddingTop64 paddingTop40Mobile">
                    <Button id="SavePersonalInfoButton" className="regular-b300 cl-secondary-100 myIeseButton" variant="text" onClick={e => !state.termsAgreed ? setTermsIncorrect() : handleSubmissionPersonalInfo(e)}>
                        {t("NextStepButton")}
                    </Button>
                </div>
                {/* <hr className="customHrMargin20" />
                <div className="flexWrapper equals">
                    <div>
                        <div className="semibold-h200">{t("PersonalInformationHeader_Subscription")}</div>
                        <div className="paddingTop8 regular-b300">{t("PersonalInformation_Footer_Features")}</div>
                    </div>
                    <div className={classes.flexLeftSubmitButton}>
                        <span className="paddingRight40">
                            <div className="semibold-h300">
                                {state.amount}€
                            </div>
                            <div className="semibold-b100">
                                {t("PerYearLiteral")}
                            </div>
                        </span>
                        <Button id="SavePersonalInfoButton" className="regular-b300 cl-secondary-100 myIeseButton" variant="text" onClick={handleSubmissionPersonalInfo}>
                            {t("NextStepButton")}
                        </Button>
                    </div>
                </div> */}
            </div>
        </div>
    );
}
export default withRouter(PersonalInformationPageInside);